import { Route } from "components/utils";
import { NotFound } from "pages/notFound";
import { UnloadingsList } from "pages/wms/unloadingsList/UnloadingsList";
import { Redirect, RouteComponentProps, Switch } from "react-router-dom";

export const Unloadings = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        exact={true}
        path={`${match.path}/list`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        component={UnloadingsList}
        exact={true}
        path={`${match.path}/list/:tab`}
        title="Milo - WMS - rozładunki"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
